var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('PageTitle',{staticClass:"strech",attrs:{"title":_vm.$t('eventos.titulo_buscar_abono')}}),_c('FormBuscarAbonado')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }